import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../utils/MouseUtils';
import animationManager from '../utils/AnimationManager';
import saveManager from '../utils/SaveManager';
import { MenuInput, PrimaryMenuButton, SecondaryMenuButton } from './SizeAndPositionButtons';
import storeManager from '../../store/StoreManager';
import {
    changeShapeOpacity, selectShape,
    updateShapePosition,
    updateShapeRotation,
    updateShapeSize
} from '../../actions/CurrentSlideActions';
import platformDetection from '../utils/PlatformDetection';

const Title = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('AnimationMenuTitle', 'other')}</span>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index == 1 && animationManager.target && !animationManager.target.animation)
            return;

        switch (this.props.index) {
            case 0: {
                animationManager.clearAnimationsInEditMode();
                animationManager.addAnimation();
                saveManager.isContentChanged(true);
                break;
            }

            case 1: {
                animationManager.clearAnimationsInEditMode();
                animationManager.deleteAnimation();
                saveManager.isContentChanged(true);
                break;
            }

            case 2: {
                animationManager.clearAnimationsInEditMode(true);
                animationManager.exitAnimationMode();
                break;
            }
        }
    },
    render() {
        var iconColor;
        var buttonColor;
        var buttonHeight = 50;
        var opacity = 1;
        var tabIndexValue;

        if (this.props.index == 0) {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#48A5E5';
            }
        } else
        if (this.props.index == 1 && animationManager.target && !animationManager.target.animation) {
            opacity = 0.5;
            buttonColor = 'gainsboro';
            tabIndexValue = '-1';
        } else {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#DCDCDC';
            }
        }

        var topPosition = this.props.windowHeight - (buttonHeight + 5) * (3 - this.props.index);

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth,
            height: buttonHeight,
            top: topPosition,
            display: 'flex',
            opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 18,
            textAlign: 'center',
            width: buttonStyle.width,
            paddingTop: 14,
            top: 0
        };

        return (
            <button id={this.props.id} aria-label={this.props.text} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const AnimationContextMenuContent = React.createClass({
    getInitialState() {
        let rotationType = 1;
        let targets = this.getTargets();

        if (animationManager.target && animationManager.target.rotationType > 0)
            rotationType = animationManager.target.rotationType;

        return {
            selectedFrame: targets.length - 1,
            targets: targets,
            rotationType: rotationType
        };
    },
    getTargets() {
        let animationTargets = animationManager.getAllAnimationTargets();
        let targets = [];
        let target;
        let item;

        for (let i=0; i<animationTargets.length; i++) {
            target = animationTargets[i];

            item = {};
            item.x = target.x;
            item.y = target.y;
            item.width = target.width;
            item.height = target.height;
            item.opacity = target.opacity * 100;
            item.rotation = target.rotation;
            item.uuid = target.uuid;
            targets.push(item);
        }

        return targets;
    },
    getSelectedFrame(targets, refreshValue) {
        if (refreshValue && refreshValue.indexOf('_') !== -1) {
            let uuid = refreshValue.split('_')[0];

            for (let i=0; i<targets.length; i++) {
                if (targets[i].uuid === uuid)
                    return i;
            }

            return this.state.selectedFrame;
        } else
            return this.state.selectedFrame;
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition){
            let targets = this.getTargets();
            let selectedFrame;

            if (targets.length - 1 < this.state.selectedFrame)
                selectedFrame = targets.length - 1;
            else
                selectedFrame = this.getSelectedFrame(targets, nextProps.refreshShapePosition);

            this.setState({
                targets: this.getTargets(),
                selectedFrame: selectedFrame
            });
        }
    },
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('animationFirstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    getShapeByIndex(index) {
        let animationTargets = animationManager.getAllAnimationTargets();

        return animationTargets[index];
    },
    getCurrentShape(){
        return this.getShapeByIndex(this.state.selectedFrame);
    },
    save(){
        animationManager.addAnimation(true);
    },
    onOpacityChange(value){
        let opacity = parseInt(value);

        if (isNaN(opacity))
            opacity = 0;

        if(opacity <= 100) {
            const dispatch = storeManager.getStore().dispatch;
            const newState = Object.assign({}, this.state);
            newState.targets[this.state.selectedFrame].opacity = opacity;
            this.setState(newState);
            dispatch(changeShapeOpacity(this.getCurrentShape(), opacity / 100));
            this.save();
        }
    },
    onPositionChange(x, y){
        x = parseInt(x);
        y = parseInt(y);

        const uuid = this.getCurrentShape().uuid;
        const dispatch = storeManager.getStore().dispatch;
        const newState = Object.assign({}, this.state);
        newState.targets[this.state.selectedFrame].x = x;
        newState.targets[this.state.selectedFrame].y = y;
        this.setState(newState);
        dispatch(updateShapePosition(uuid, x, y));
        this.save();
    },
    onRotationChange(rotation) {
        rotation = parseInt(rotation);

        if(rotation >= 0) {
            const dispatch = storeManager.getStore().dispatch;
            const newState = Object.assign({}, this.state);
            newState.targets[this.state.selectedFrame].rotation = rotation;
            this.setState(newState);
            dispatch(updateShapeRotation(this.getCurrentShape().uuid, rotation));
            this.save();
        }
    },
    onZoom(type){
        const shapeModel = this.getCurrentShape();
        let hasChanged = false;

        const aspectRatio = shapeModel.height/shapeModel.width;
        let newHeight = shapeModel.height;
        let newWidth = shapeModel.width;

        if (type === "in") {
            if (shapeModel.width > 10 && shapeModel.height > aspectRatio * 10) {
                newWidth = shapeModel.width - 10;
                newHeight = shapeModel.height - aspectRatio*10;
                hasChanged = true;
            }
        } else {//out
            newWidth = shapeModel.width + 10;
            newHeight = shapeModel.height + aspectRatio*10;
            hasChanged = true;
        }

        if(hasChanged){
            const dispatch = storeManager.getStore().dispatch;
            const newState = Object.assign({}, this.state);
            newState.targets[this.state.selectedFrame].width = newWidth;
            newState.targets[this.state.selectedFrame].height = newHeight;
            this.setState(newState);
            dispatch(updateShapeSize(shapeModel.uuid, newWidth, newHeight, shapeModel.x, shapeModel.y));
            this.save();
        }
    },
    onClickPrimaryButton(type) {
        if (type === this.state.selectedFrame)
            return;

        this.setState({
            selectedFrame: type
        });

        const dispatch = storeManager.getStore().dispatch;
        let animationTargets = animationManager.getAllAnimationTargets();

        if (animationTargets[type])
            dispatch(selectShape(animationTargets[type].uuid));
    },
    onRotationTypeClick(type) {
        animationManager.rotationType = type;

        if (type === 0 || type === 1 || type === 2)
            animationManager.deleteClones(true);

        this.setState({
            rotationType: type
        });
    },
    render() {
        if (this.props.contextMode != modeType.ANIMATION_CONTEXT)
            return <div/>;

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            cursor: 'default'
        };

        const wrapper = {
            height: this.props.windowHeight - 165,
            overflowY: 'auto',
            overflowX: 'hidden'
        };

        const inputAreaStyle = {
            marginTop: '40px',
            padding: '0 8px'
        };

        var currentShape = this.getCurrentShape();
        const opacity = currentShape.opacity * 100;
        const rotation = currentShape.rotation;

        const smallTextStyle = {
            fontSize: '12px',
            textAlign: 'center'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        const topButtonsWrapperStyle = {
            display: 'block',
            marginTop: '10px'
        };

        const lineStyle = {
            width: '100%',
            height: 1,
            background: 'black',
            marginTop: 5
        };

        let targets = this.state.targets;
        let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let buttons = [];
        let id;
        let i;

        for (i=0; i<targets.length; i++) {
            if (i === 0)
                id = 'animationFirstFocusableObject';

            buttons.push(<PrimaryMenuButton id={id} clickHandler={this.onClickPrimaryButton}
                               type={i} isToggleButton={true} isSelected={this.state.selectedFrame === i} caption={letters[i]} key={'primary_' + i} targets={targets.length}/>);
        }

        const rotationButtonsWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
        };

        let rotationButtons = [];

        for (i=0; i<4; i++) {
            rotationButtons.push(<PrimaryMenuButton  clickHandler={this.onRotationTypeClick}
                                            type={i} isToggleButton={true} isSelected={this.state.rotationType === i} caption={letters[i]} key={'rotationType_' + i} targets={4}/>);
        }

        return (
            <div style={menuStyle} id="animationMenu">
                <Title accordionWidth={this.props.accordionWidth}/>

                <div style={wrapper}>
                    <div style={inputAreaStyle}>
                        <h3 style={smallTextStyle}>{locales.getCaption('SelectFrame', 'advancedMenu')}</h3>

                        <div style={topButtonsWrapperStyle}>
                            {buttons}
                        </div>

                        <div style={lineStyle}/>
                        <h3 style={smallTextStyle}>{locales.getCaption('Opacity', 'advancedMenu')}</h3>
                        <div style={buttonWrapperStyle}>
                            <MenuInput isInt={true}
                                       labelText={locales.getCaption('OpacityValue', 'advancedMenu') + '(0-100)'}
                                       value={opacity} onChangeHandler={this.onOpacityChange}/>
                        </div>

                        <div style={lineStyle}/>
                        <h3 style={smallTextStyle}>{locales.getCaption('Position', 'advancedMenu')}</h3>
                        <div style={buttonWrapperStyle}>
                            <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'advancedMenu')}
                                       value={currentShape.x} yValue={currentShape.y}
                                       onChangeHandler={this.onPositionChange}/>
                            <MenuInput isInt={true} labelText={locales.getCaption('Yposition', 'advancedMenu')}
                                       value={currentShape.y} xValue={currentShape.x}
                                       onChangeHandler={this.onPositionChange}/>
                        </div>

                        <div style={lineStyle}/>
                        <h3 style={smallTextStyle}>{locales.getCaption('Zoom', 'advancedMenu')}</h3>
                        <div style={buttonWrapperStyle}>
                            <SecondaryMenuButton clickHandler={this.onZoom} type={'in'}
                                                 caption={locales.getCaption('ZoomIn', 'advancedMenu')}/>
                            <SecondaryMenuButton clickHandler={this.onZoom} type={'out'}
                                                 caption={locales.getCaption('ZoomOut', 'advancedMenu')}/>
                        </div>

                        {(window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('localhost') !== -1) ?
                            <div>
                                <div style={lineStyle}/>
                                <h3 style={smallTextStyle}>{locales.getCaption('Rotation', 'sizePosMenu')}</h3>
                                <div style={buttonWrapperStyle}>
                                    <MenuInput isInt={true}
                                               labelText={locales.getCaption('SetRotationInDegrees', 'sizePosMenu')}
                                               value={rotation} onChangeHandler={this.onRotationChange}/>
                                </div>
                                <div style={rotationButtonsWrapperStyle}>
                                    {rotationButtons}
                                </div>
                            </div> : null
                        }
                    </div>
                </div>

                <Button accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} index={0}
                        text={locales.getCaption('Ok', 'other')}/>
                <Button accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} index={1}
                        text={locales.getCaption('Delete', 'other')}/>
                <Button id='animationMenuLastFocusableObject' accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} index={2} text={locales.getCaption('Cancel', 'other')}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var refreshShapePosition = state.menu.refreshShapePosition;

    return {
        refreshShapePosition
    };
}

export const AnimationContextMenu = connect(mapStateToProps)(AnimationContextMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/AnimationContextMenu.js
 **/